import React from "react";
import styled from "styled-components";

import { Flex } from "../../../components/Flex";
import { Spacing } from "../../../theme/Spacing";
import { PrivatePricingPlans } from "../components/PrivatePricingPlans";

const Container = styled(Flex)`
  flex-wrap: wrap;
  gap: ${Spacing.xxl};
  margin-bottom: ${Spacing.xxl};
  width: 100%;
  min-width: 0;
`;

const Content = styled(Flex)`
  flex-direction: column;
  gap: ${Spacing.xl};
  width: 100%;
  height: fit-content;
  min-width: 0;
`;

export const SubscriptionPlansTab: React.FC = () => {
  return (
    <Container>
      <Content>
        {/* <Flex flexDirection="column">
          <Text fontWeight={"bold"} fontSize="l">
            {t("subscription.page.paymentInfo.title")}
          </Text>
          <Text fontSize="m">
            {t("subscription.page.paymentInfo.description")}
          </Text>
        </Flex> */}
        <PrivatePricingPlans />
      </Content>
    </Container>
  );
};
